import axios from 'axios'

/**
 * 発番サービス
 */
export default class NumberIssuingService {
    /** 発番種別コード定義 */
    /** 見積書 */
    public static readonly ESTIMATE = 1
    /** 検査依頼書(輸入検査) */
    public static readonly REQUEST_IMPORT = 2
    /** 検査依頼書(一般検査 日本デリカフーズ分) */
    public static readonly REQUEST_CSV = 3
    /** 検査依頼書(一般検査 横浜検査センター検査分) */
    public static readonly REQUEST_GROUP = 4
    /** 検査依頼書(一般検査) */
    public static readonly REQUEST_GENERAL = 5
    /** 検査 */
    public static readonly INSPECT = 6
    /** 請書 */
    public static readonly CONFIRMATION = 7
    /** 報告書 */
    public static readonly REPORT = 8
    /** 請求書 */
    public static readonly INVOICE = 9
    /** 代理店請求書 */
    public static readonly AGENCY_INVOICE = 10
    /** 合計請求書 */
    public static readonly TOTAL_INVOICE = 11

    /** インスタンス */
    private static _instance: NumberIssuingService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new NumberIssuingService();
        }
        return this._instance;
    }

    /**
     * 次の番号をを取得
     */
    public async next(numberIssuingCode: number, slipDate: string): Promise<string> {
        return await axios.get(`/api/number_issuing/${numberIssuingCode}/${slipDate}`)
            .then((results) => {
                if (results.status === 200) {
                    return results.data
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }
}
